export const AdCardIndexList = [2, 6, 9];
export const AdCardIndexSet = new Set(AdCardIndexList);
